module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetLow@2x.c425c66.jpg";